import React, { useRef, useLayoutEffect, useState } from "react";
import { Box, Button, TextField, Skeleton, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import SearchIcon from "../../assets/icons/search-icon.svg";

interface ListTopSectionProps {
  isLoading: boolean;
  isOwner: boolean;
  stakeListLength: number;
  value: string;
  onChange: (val: string) => void;
  onAddClick: () => void;
  isSearchPending: boolean;
}

const ListTopSection: React.FC<ListTopSectionProps> = ({
  isLoading,
  isOwner,
  stakeListLength,
  value,
  onChange,
  onAddClick,
  isSearchPending,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);

  const [searchValue, setSearchValue] = useState("");

  // Keep cursor at end
  // useLayoutEffect(() => {
  //   const input = searchInputRef.current;
  //   if (input) {
  //     input.focus();
  //     const length = input.value.length;
  //     input.setSelectionRange(length, length);
  //   }
  // }, [value]);

  return (
    <Box
      sx={{
        position: "sticky",
        top: "-16px",
        backgroundColor: "white",
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "28px 28px 20px 38px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          maxHeight: "34px",
          minWidth: "306px",
          position: "relative",
        }}
      >
        {isLoading && (
          <Skeleton
            variant="text"
            width={"200px"}
            height={60}
            sx={{ position: "absolute", left: 0 }}
          />
        )}

        {isOwner && (stakeListLength > 0 || value) && (
          <Button
            variant="outlined"
            className="listpage-add-button"
            onClick={onAddClick}
            sx={{
              borderRadius: "4px !important",
              padding: "6px 10px !important",
            }}
          >
            <Box display="flex" alignItems="center" gap="4px">
              <AddRoundedIcon sx={{ color: "#ffffff" }} />
              <Typography className="listpage-add-button-text">
                New stakeholder
              </Typography>
            </Box>
          </Button>
        )}

        <TextField
          inputRef={searchInputRef}
          variant="outlined"
          placeholder="Search"
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value ?? "");
            onChange(e.target.value ?? "");
          }}
          InputProps={{
            startAdornment: (
              <Box display="flex" alignItems="center" gap="4px">
                <img
                  src={SearchIcon}
                  style={{
                    width: 12,
                    height: 12,
                    marginLeft: "16px",
                    marginRight: "10px",
                  }}
                />
              </Box>
            ),
            sx: {
              padding: "4px 8px",
              paddingLeft: "0 !important",
              fontSize: "14px",
              height: "35px",
            },
          }}
          sx={{
            borderRadius: "4px !important",
            width: "200px",
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            },
            "& .MuiOutlinedInput-input::placeholder": {
              color: "rgba(35, 35, 35, 1)",
              fontWeight: "300 !important",
              opacity: 1,
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ListTopSection;
